module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/~/core-js/modules/_path.js
// module id = 265
// module chunks = 0